"use client";
import { IoMdAddCircle } from "react-icons/io";
import { MdCreate } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { IoIosEye } from "react-icons/io";
import { Stack } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useI18n } from "../i18n";

type CreateEditDeleteButtonGroupProps = {
  hasCreate?: boolean;
  hasEdit?: boolean;
  hasDelete?: boolean;
  hasView?: boolean;
  disableCreate?: boolean;
  disableEdit?: boolean;
  disableDelete?: boolean;
  disableView?: boolean;
  onCreateButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onEditButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onDeleteButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onViewButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function CreateEditDeleteButtonGroup({
  hasCreate = true,
  hasEdit = true,
  hasDelete = true,
  hasView = false,
  disableCreate = false,
  disableEdit = false,
  disableDelete = false,
  disableView = false,
  onCreateButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onViewButtonClick,
}: CreateEditDeleteButtonGroupProps) {
  const { t } = useI18n();
  const createButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (typeof onCreateButtonClick === "function") {
      onCreateButtonClick(event);
    }
  };

  const editButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (typeof onEditButtonClick === "function") {
      onEditButtonClick(event);
    }
  };

  const deleteButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (typeof onDeleteButtonClick === "function") {
      onDeleteButtonClick(event);
    }
  };

  const viewButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (typeof onViewButtonClick === "function") {
      onViewButtonClick(event);
    }
  };

  return (
    <Stack direction="horizontal" gap={2} style={{ float: "right" }}>
      {hasCreate && (
        <Button
          variant="secondary"
          className="mr-2"
          onClick={createButtonClick}
          disabled={disableCreate}
        >
          <IoMdAddCircle className="d-inline mr-1 mb-1" />
          {t("common.add")}
        </Button>
      )}
      {hasEdit && (
        <Button
          variant="secondary"
          className="mr-2"
          onClick={editButtonClick}
          disabled={disableEdit}
        >
          <MdCreate className="d-inline mr-1 mb-1" />
          {t("common.edit")}
        </Button>
      )}
      {hasView && (
        <Button
          variant="secondary"
          className="mr-2"
          onClick={viewButtonClick}
          disabled={disableView}
        >
          <IoIosEye className="d-inline mr-1 mb-1" />
          {t("common.view")}
        </Button>
      )}
      {hasDelete && (
        <Button
          variant="danger"
          className="mr-2"
          onClick={deleteButtonClick}
          disabled={disableDelete}
        >
          <RiDeleteBin6Fill className="d-inline mr-1  mb-1" />
          {t("common.delete")}
        </Button>
      )}
    </Stack>
  );
}
